export type InstallUiState = "off" | "available" | "installed" | "hint";

export const BEACH_POP_CACHE_PREFIX = "beach-pop";
export const PRIVATE_PWA_CACHE = "beach-pop-private-test-v1";
export const LEGACY_PWA_CACHE = "beach-pop-v1";

export function isBeachPopCacheName(name: string): boolean {
  return name === LEGACY_PWA_CACHE || name.startsWith(`${BEACH_POP_CACHE_PREFIX}-`);
}

export function isBeachPopServiceWorkerUrl(scriptURL: string): boolean {
  if (!scriptURL) return false;
  try {
    const { pathname } = new URL(scriptURL, "http://local.test");
    return pathname.endsWith("/sw.js");
  } catch {
    return /(?:^|\/)sw\.js$/i.test(scriptURL);
  }
}

export function shouldRegisterServiceWorker(pwaEnabled: boolean): boolean {
  return pwaEnabled;
}

export function shouldListenForInstallPrompt(pwaEnabled: boolean): boolean {
  return pwaEnabled;
}

export function shouldCleanupLegacyPwa(pwaEnabled: boolean): boolean {
  return !pwaEnabled;
}

export function isStandaloneDisplay(matches: (query: string) => boolean, iosStandalone: boolean): boolean {
  return iosStandalone || matches("(display-mode: standalone)") || matches("(display-mode: fullscreen)");
}

export function resolveInstallUiState(input: {
  pwaEnabled: boolean;
  canPrompt: boolean;
  installed: boolean;
}): InstallUiState {
  if (!input.pwaEnabled) return "off";
  if (input.installed) return "installed";
  if (input.canPrompt) return "available";
  return "hint";
}

export function publicBuildContainsPwa(files: string[]): boolean {
  const names = files.map((file) => file.replaceAll("\\", "/").toLowerCase());
  return names.some((file) => file.endsWith("/sw.js") || file.endsWith("sw.js") || file.endsWith(".webmanifest"));
}

export function privateBuildHasPwaFiles(files: string[]): boolean {
  const names = files.map((file) => file.replaceAll("\\", "/").toLowerCase());
  return names.some((file) => file.endsWith("/sw.js") || file.endsWith("sw.js")) && names.some((file) => file.endsWith(".webmanifest"));
}
